<template>
  <div class="dashboard">
    <div style="width:1140px">

      <div id="library" class="dashboard-container">

        <div class="dashboard-toplayout">
          <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
          <span class="dashboard-toplayout-ftsbig">馆藏著录</span>

        </div>
        <el-form ref="form" v-loading="loading" :model="form" label-position="top" label-width="80px" :inline="false" size="normal">
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">
              <el-form-item class="require" label="题名" prop="collectionName" size="normal" :rules="[{required: true, message: '请输入标题', trigger: 'blur'}]">
                <el-input v-model="form.collectionName" class="count" placeholder="" type="textarea" maxlength="50" show-word-limit size="normal" clearable @blur="changeDescript" />
                <span class="placeholder-span">请概括填写本馆藏的内容标题，最多50字</span>
              </el-form-item>

            </el-col>
            <el-col :span="12" :offset="0">
              <!-- :rules="[{required: true, message: '请输入标题', trigger: 'blur'}]"> -->
              <el-form-item label="副题名" prop="subtitle" size="normal">
                <el-input v-model="form.subtitle" class="count" placeholder="" type="textarea" maxlength="50" show-word-limit size="normal" clearable @blur="changeDescript" />

                <span class="placeholder-span">请概括填写本馆藏的内容副标题，最多50字</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="6" :offset="0">
              <el-form-item label="目次" prop="chapter" size="normal">
                <el-input
                  v-model="form.chapter"
                  class="count"
                  show-word-limit
                  maxlength="10"
                  placeholder=""
                  size="normal"
                  clearable
                  @blur="changeDescript"
                />
                <span class="placeholder-span">系列馆藏中单件馆藏的名称，如：第一讲</span>
              </el-form-item>

            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="目次序列" prop="chapterOrder" size="normal">
                <!-- <el-input v-model="form.chapterOrder" onkeyup="this.value = this.value.replace(/[^\d]/g,'');" placeholder="" size="normal" /> -->
                <el-input v-model="form.chapterOrder" class="count" show-word-limit maxlength="4" oninput="value=value.replace(/[^\d]/g,'')" onkeyup="this.value = this.value.replace(/[^\d]/g,'');" placeholder="" size="normal" />

                <span class="placeholder-span">请输入1-9999阿拉伯数字
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider direction="horizontal" />
          <el-row :gutter="20">
            <el-col :span="6" :offset="0">
              <el-form-item class="require" label="馆藏分类" prop="cateId" size="normal" :rules="[{required: true, message: '请选择馆藏分类', trigger: 'change'}]">

                <el-cascader v-model="form.cateId" style="width:100%" :options="categoryTree" :props="categoryProps" @change="categoryTreeChange" />
                <span class="placeholder-span">馆藏所属分类</span>
              </el-form-item>

            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="关联学科" prop="subjectId" size="normal">

                <el-cascader v-model="form.subjectId" style="width:100%" :options="subjectTree" clearable :props="subjectProps" @change="subjectTreeChange" />

                <span class="placeholder-span">馆藏所属学科</span>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="0">

              <el-form-item label="关联专题" prop="topicId" size="normal">
                <el-select v-model="form.topicId" style="width:100%" clearable filterable allow-create default-first-option placeholder="" @change="topicChange">
                  <el-option v-for="item in topicTree" :key="item.id" :label="item.topicName" :value="item.id" />
                </el-select>
                <span class="placeholder-span">馆藏所属专题</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider direction="horizontal" />
          <el-row :gutter="20">
            <el-col :span="6" :offset="0">
              <el-form-item class="require" label="馆藏责任者" prop="responsibleOfficer" size="normal" :rules="[{required: true, message: '请填写创建馆藏内容的主要责任者', trigger: 'blur'}]">
                <el-input v-model="form.responsibleOfficer" class="count" show-word-limit maxlength="20" placeholder="" size="normal" clearable @blur="changeDescript" />
                <span class="placeholder-span">创建馆藏内容的主要责任者</span>
              </el-form-item>

            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item class="require" label="馆藏责任者责任方式" prop="responsibleMethod" size="normal" :rules="[{required: true, message: '请填写馆藏责任者责任方式', trigger: 'blur'}]">
                <el-input v-model="form.responsibleMethod" class="count" show-word-limit maxlength="10" placeholder="" size="normal" clearable />

              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="其它责任者" prop="otherResponsibleOfficer" size="normal">
                <el-input v-model="form.otherResponsibleOfficer" class="count" show-word-limit maxlength="20" placeholder="" size="normal" clearable @blur="changeDescript" />
                <span class="placeholder-span">创建馆藏内容的其它责任者</span>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="其它责任者责任方式" prop="otherResponsibleMethod" size="normal">
                <el-input v-model="form.otherResponsibleMethod" class="count" show-word-limit maxlength="10" placeholder="" size="normal" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider direction="horizontal" />
          <el-row :gutter="20">
            <el-col :span="6" :offset="0">
              <el-form-item label="来源出版物" prop="publications" size="normal">
                <el-input v-model="form.publications" class="count" show-word-limit maxlength="50" placeholder="" size="normal" clearable @blur="changeDescript" />
                <span class="placeholder-span">馆藏来源出版物的名称</span>
              </el-form-item>

            </el-col>
            <el-col :span="6" :offset="0">

              <el-form-item label="出版者" prop="publisher" size="normal">
                <el-input v-model="form.publisher" show-word-limit maxlength="20" class="cascader count" placeholder="" size="normal" clearable>

                  <!-- <el-select class="select" style="width:100px;padding:0px" v-model="form.publishArea" slot="prepend" placeholder="">
                  <el-option label="餐厅名" value="1"></el-option>
                  <el-option label="订单号" value="2"></el-option>
                  <el-option label="用户电话" value="3"></el-option>
                </el-select> -->

                  <el-cascader slot="prepend" v-model="form.publishArea" style="width:100px;padding:0px 0px" clearable :show-all-levels="false" :options="regiontree" :props="regionProps" />

                </el-input>
                <span class="placeholder-span">馆藏来源出版物的出版者和出版地</span>
              </el-form-item>

            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="出版日期" prop="publishTime" size="normal">
                <el-date-picker v-model="form.publishTime" value-format="yyyy-MM-dd" style="width:100%" placeholder="" />
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="来源出版物标识符" prop="publicationsCode" size="normal">
                <el-input v-model="form.publicationsCode" class="count" show-word-limit maxlength="100" placeholder="" size="normal" clearable @change="publicationsTypeChange">

                  <el-select slot="prepend" v-model="form.publicationsType" class="select" style="width:100px;padding:0px" placeholder="">
                    <el-option v-for="item in publicationOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                  </el-select>

                </el-input>
                <span class="placeholder-span">馆藏出版物的标识类型和标识码</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider direction="horizontal" />
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">

              <el-form-item class="require" label="版权拥有者" prop="copyrightOwner" size="normal" :rules="[{required: true, message: '请输入版权拥有者', trigger: 'blur'}]">
                <el-input v-model="form.copyrightOwner" class="count" show-word-limit maxlength="50" placeholder="" :disabled="form.copyrightOwnerType===1" size="normal" clearable @change="copyrightOwnerInPutChange">
                  <el-select slot="prepend" v-model="form.copyrightOwnerType" class="select" style="width:100px;padding:0px" placeholder="" @change="copyrightChange">
                    <el-option v-for="item in copyrightOptions " :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                  </el-select>
                </el-input>
                <span class="placeholder-span">拥有版权的个体或机构名称</span>
              </el-form-item>

            </el-col>

            <el-col v-if="form.copyrightOwnerType===2" :span="6" :offset="0">
              <!-- :rules="[{required: true, message: '版权结束日期', trigger: 'blur'}] -->
              <el-form-item label="版权结束日期" prop="copyrightExpiresTime" size="normal">
                <el-date-picker v-model="form.copyrightExpiresTime" value-format="yyyy-MM-dd" style="width:100%" placeholder="" />
              </el-form-item>
            </el-col>
            <!-- :rules="[{required: true, message: '请转载网址', trigger: 'blur'}]" -->
            <el-col v-if="form.copyrightOwnerType===3" :span="6" :offset="0">
              <el-form-item label="转载网址" prop="transWeb" size="normal">
                <el-input v-model="form.transWeb" class="count" show-word-limit maxlength="100" placeholder="" size="normal" clearable />
              <!-- <span class="placeholder-span">创建馆藏内容的其它责任者</span> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider direction="horizontal" />
          <el-row :gutter="20">
            <el-col :span="6" :offset="0">

              <el-form-item label="馆藏级别" prop="collectionLevel" size="normal">

                <el-select v-model="form.collectionLevel" clearable style="width:100%" placeholder="">
                  <el-option v-for="item in collectionleverOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                </el-select>
                <span class="placeholder-span">馆藏使用群体范围</span>
              </el-form-item>

            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="典型年龄范围" prop="ageRange" size="normal">

                <el-select v-model="form.ageRange" style="width:100%" clearable placeholder="">
                  <el-option v-for="item in typicalagerangeOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                </el-select>
                <span class="placeholder-span">请选择</span>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="馆藏信息" prop="collectionInfo" size="normal">
                <el-input v-model="form.collectionInfo" class="count" maxlength="20" show-word-limit placeholder="" size="normal" clearable />
                <span class="placeholder-span">收藏资料的物理实体</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider direction="horizontal" />
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">

              <el-form-item class="require" label="馆藏描述" prop="description" size="normal" :rules="[{required: true, message: '请填写馆藏描述', trigger: 'blur'}]">
                <el-input v-model="form.description" class="discript" style=" height: 170px;" placeholder="" type="textarea" maxlength="2000" show-word-limit size="normal" clearable @blur="changeDescript" />
                <span class="placeholder-span">对馆藏内容相关的描述说明、附注等</span>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item class="require" label="馆藏封面" prop="preview" size="normal" :rules="[{required: true, message: '请上传馆藏封面', trigger: 'blur'}]">
                <div class="image">
                  <img v-if="!form.preview" src="@/assets/img1.png" alt="404">
                  <el-image v-else :src="form.preview" style="width: 260px; height: 170px;" fit="contain" :lazy="true" />

                </div>
                <span class="placeholder-span"> 可上传本地图片做为馆藏封面，也可将已上传的图片设为封面</span>

              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="0">
              <el-form-item label="   " size="normal">
                <div class="upload">
                  <el-upload ref="upload" action="" style="padding:0px;" accept=".jpg,.png" :http-request="fileupload" :show-file-list="false">

                    <div class="upload-btn"> <img style="margin-left: 10px;" src="@/assets/upload.png" alt="404">上传本地图片</div>

                  </el-upload>
                  <div class="upload-btn" @click="selectImage()"> <img style="margin-left: 10px;" src="@/assets/choice.png" alt="404">选择已上传的图片</div>

                </div>

              </el-form-item>
            </el-col>
          </el-row>
          <el-divider direction="horizontal" />
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">

              <el-form-item label="关键词" prop="keyword" size="normal">

                <el-input v-model="form.keyword" class="count" maxlength="50" show-word-limit placeholder="" size="normal" />
                <span class="placeholder-span">馆藏的描述性关键词，可输入3-5个，用“空格”分隔</span>
              </el-form-item>

            </el-col>

          </el-row>
          <el-divider direction="horizontal" />
          <el-row :gutter="20">
            <el-col :span="8" :offset="0">

              <el-form-item label="纪事时间" size="normal">

                <label class="placeholder">本馆藏所涉及到的时间点</label>
                <div class="tags">

                  <!-- <el-tag v-for="(item, index) in chronicleDateform" :key="index" :style="index===0?'margin:0px 0px 10px 0px':'margin:0px 0px 10px 10px'" type="info" size="normal" closable @close="removeChronicleDate(index)">{{ item }}</el-tag> -->
                  <el-tag v-if="form.chronicleDate!==''" style="margin:0px 0px 10px 0px;" type="info" size="normal" closable @close="removeChronicleDate()">{{ form.chronicleDate }}</el-tag>

                </div>
                <div>
                  <el-input v-model="inputDataTags" class="tags-input" placeholder="" size="normal">

                    <img slot="append" style="width: 26px;height: 26px;" src="@/assets/send.png" alt="404" @click="inputDateTagsChange">

                  </el-input>
                </div>

                <span class="placeholder-span">手动添加:请按“年:年/月:年/月/日”格式提交,例: 2000/01</span>
                <div class="tags" style="height:60px">

                  <el-tag v-for="(item, index) in dataTimeList" :key="index" :style="index!=0?'margin-left:10px':''" :type="item.isclick?'success':'info'" size="normal" @click="inputChronicleDate(item)">{{ item.name }}</el-tag>

                </div>
                <span class="placeholder-span">AI识别添加：蓝色信息点击录入。灰色信息仅供参考</span>

              </el-form-item>

            </el-col>
            <el-col :span="8" :offset="0">

              <el-form-item label="纪事地点" prop="areaAffected" size="normal">

                <label class="placeholder">本馆藏所涉及到的地点</label>
                <div class="tags">

                  <el-tag v-for="(item, index) in areaAffectedform" :key="index" :style="index===0?'margin:0px 0px 10px 0px':'margin:0px 0px 10px 10px'" type="info" size="normal" closable @close="removeChronicleAdress(index)">{{ item.regionName }}</el-tag>

                </div>
                <div>
                  <el-select v-model="inputAdressTags" class="tags-input" style="width:100%" filterable remote reserve-keyword placeholder="请输入" :remote-method="remoteMethod" :loading="adressing" @change="inputAdressTagsChange">
                    <el-option v-for="item in adressoptions" :key="item.regionCode" :label="item.allRegionName" :value="item.regionCode" />
                  </el-select>
                <!-- <el-input class="tags-input" v-model="inputAdressTags" placeholder="" size="normal">
                  <img slot="append" style="width: 26px;height: 26px;" src="@/assets/send.png" alt="404" @click="inputAdressTagsChange" />
                </el-input> -->
                </div>
                <span class="placeholder-span">手动添加：请输入地区全称提交，例：沙坪坝区</span>

                <div class="tags" style="height:60px">

                  <el-tag v-for="(item, index) in adressList" :key="index" :style="index!=0?'margin-left:10px':''" type="success" size="normal" @click="inputChronicleAdress(item)">{{ item.regionName }}</el-tag>

                </div>
                <span class="placeholder-span">AI识别添加:蓝色信息点击录入。灰色信息仅供参考</span>

              </el-form-item>

            </el-col>
            <el-col :span="8" :offset="0">

              <el-form-item label="纪事人物" size="normal">

                <label class="placeholder">本馆藏所涉及到的人物姓名</label>
                <div class="tags">

                  <el-tag v-for="(item, index) in personAffectedform" :key="index" :style="index===0?'margin:0px 0px 10px 0px':'margin:0px 0px 10px 10px'" type="info" size="normal" closable @close="removeChroniclePerson(index)">{{ item }}</el-tag>

                </div>
                <div>
                  <el-input v-model="inputPersonTags" class="tags-input" placeholder="" size="normal">
                    <img slot="append" style="width: 26px;height: 26px;" src="@/assets/send.png" alt="404" @click="inputPersonTagsChange">
                  </el-input>
                </div>
                <span class="placeholder-span">手动添加:输入后点击按钮提交</span>

                <div class="tags" style="height:60px">

                  <el-tag v-for="(item, index) in personList" :key="index" :style="index!=0?'margin-left:10px':''" type="success" size="normal" @click="inputChroniclePerson(item)">{{ item }}</el-tag>

                </div>
                <span class="placeholder-span">AI识别添加：蓝色信息点击录入。灰色信息仅供参考</span>

              </el-form-item>

            </el-col>
          </el-row>
        </el-form>

      </div>
      <div id="resourse" class="dashboard-container">

        <div class="dashboard-toplayout">
          <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
          <span class="dashboard-toplayout-ftsbig">资源著录</span>
          <div class="dashboard-toplayout-right">
            <el-button type="primary" style="width: 90px;height: 30px;background: #4C70E8;border-radius: 5px;" size="small" @click="resourseDes">批量著录</el-button>

          </div>
        </div>
        <div v-for="(item, index) in form.resources" :key="index" :style="index!=0?'margin-top:10px':''" style="display:flex;align-items:center">
          <!-- <div style="width:174px;height:117px"> -->

          <div class="chronicle-bottom-type" @click="lookResourse(item)">
            <el-image v-if="item.resourceType==='video'" :src="item.previewUrl" style="width:100%;height:100%" fit="contain" :lazy="true" />
            <el-image v-else-if="item.resourceType==='image'" :src="item.resourceCloudUrl" style="width:100%;height:100%" fit="contain" :lazy="true" />

            <img v-else-if="item.resourceType==='audio'" src="@/assets/rec1.png" alt="404">
            <img v-else-if="item.resourceType==='zip'" src="@/assets/zip1.png" alt="404">
            <img v-else-if="item.resourceType==='pdf'" src="@/assets/pdf1.png" alt="404">

            <img class="chronicle-bottom-search" src="@/assets/search.png" alt="404">
          </div>
          <!-- </div> -->

          <div v-if="item.resourceType==='video'" style="width:876px;margin-left:10px">
            <el-descriptions class="descriptions" title="" direction="horizontal" size="mini" :column="5" border>
              <el-descriptions-item :span="5" label="资源名称">
                <el-input v-model="item.resourceName" maxlength="50" show-word-limit sjpw style="width:100%" placeholder="请输入" size="normal" />
              </el-descriptions-item>
              <el-descriptions-item :span="5" label="资源描述">
                <el-input v-model="item.description" maxlength="100" show-word-limit style="width:100%" placeholder="请输入" size="normal" />
              </el-descriptions-item>
              <el-descriptions-item label="资源体载">

                <!-- <div style="width:114px">18100000000</div> -->
                <!-- <el-select class="resourse descriptions-one" style="width:106px" v-model="form.select" placeholder="">
                <el-option label="餐厅名" value="1"></el-option>
                <el-option label="订单号" value="2"></el-option>
                <el-option label="用户电话" value="3"></el-option>
              </el-select> -->
                <div class="resourse descriptions-one">
                  <el-cascader ref="cascaderhandle" v-model="item.genre" clearable class="trantree" :show-all-levels="false" :options="genretree" :props="genreProps" @change="changeTrain" />

                </div>

              </el-descriptions-item>
              <el-descriptions-item label="创作日期">
                <el-select v-model="item.chronicleDate" clearable class="resourse descriptions-one" placeholder="" @focus="focustotal(index)">
                  <!-- <el-option label="餐厅名" value="1"></el-option>
                <el-option label="订单号" value="2"></el-option>
                <el-option label="用户电话" value="3"></el-option> -->

                  <el-option v-for="(item, index) in datatotal" :key="index" :label="item" :value="item" />
                </el-select>
              <!-- <div style="width:114px">18100000000</div> -->
              </el-descriptions-item>
              <el-descriptions-item label="纪事人物">
                <el-select v-model="item.personAffected" class=" resourse descriptions-one inputtag " collapse-tags multiple placeholder="">
                  <el-option v-for="(item, index) in personAffectedform" :key="index" :label="item" :value="item" />
                </el-select>

              </el-descriptions-item>

              <el-descriptions-item :span="1" label="字幕语种">

                <el-select v-model="item.subtitlesLangue" clearable class="resourse descriptions-one" placeholder="">
                  <el-option v-for="item in langueOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                </el-select>

              </el-descriptions-item>
              <el-descriptions-item :span="1" label="音频语种">

                <el-select v-model="item.videoAndAudioLangue" clearable class="resourse descriptions-one" placeholder="">
                  <el-option v-for="item in langueOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                </el-select>

              </el-descriptions-item>

              <el-descriptions-item :span="5" label="格式信息">
                <span style="margin-left:5px">{{ item.resourceSuffix }}</span>
              </el-descriptions-item>

            </el-descriptions>
          </div>
          <div v-else-if="item.resourceType==='audio'" style="width:876px;margin-left:10px">
            <el-descriptions class="descriptions" title="" direction="horizontal" size="mini" :column="5" border>
              <el-descriptions-item :span="5" label="资源名称">
                <el-input v-model="item.resourceName" maxlength="50" show-word-limit style="width:100%" placeholder="请输入" size="normal" />
              </el-descriptions-item>
              <el-descriptions-item :span="5" label="资源描述">
                <el-input v-model="item.description" maxlength="100" show-word-limit style="width:100%" placeholder="请输入" size="normal" />
              </el-descriptions-item>
              <el-descriptions-item label="资源体载">

                <!-- <div style="width:114px">18100000000</div> -->
                <!-- <el-select class="resourse descriptions-one" style="width:106px" v-model="form.select" placeholder="">
                <el-option label="餐厅名" value="1"></el-option>
                <el-option label="订单号" value="2"></el-option>
                <el-option label="用户电话" value="3"></el-option>
              </el-select> -->
                <div class="resourse descriptions-one">
                  <el-cascader ref="cascaderhandle" v-model="item.genre" clearable class="trantree" :show-all-levels="false" :options="genretree" :props="genreProps" @change="changeTrain" />

                </div>

              </el-descriptions-item>
              <el-descriptions-item label="创作日期">
                <el-select v-model="item.chronicleDate" clearable class="resourse descriptions-one" placeholder="" @focus="focustotal(index)">
                  <!-- <el-option label="餐厅名" value="1"></el-option>
                <el-option label="订单号" value="2"></el-option>
                <el-option label="用户电话" value="3"></el-option> -->

                  <el-option v-for="(item, index) in datatotal" :key="index" :label="item" :value="item" />
                </el-select>
              <!-- <div style="width:114px">18100000000</div> -->
              </el-descriptions-item>
              <el-descriptions-item label="纪事人物">
                <el-select v-model="item.personAffected" class=" resourse descriptions-one inputtag " collapse-tags multiple placeholder="">
                  <el-option v-for="(item, index) in personAffectedform" :key="index" :label="item" :value="item" />
                </el-select>

              </el-descriptions-item>

              <el-descriptions-item v-if="item.resourceType==='video'" :span="1" label="字幕语种">

                <el-select v-model="item.subtitlesLangue" clearable class="resourse descriptions-one" placeholder="">
                  <el-option v-for="item in langueOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                </el-select>

              </el-descriptions-item>
              <el-descriptions-item :span="3" label="音频语种">

                <el-select v-model="item.videoAndAudioLangue" clearable class="resourse descriptions-two" placeholder="">
                  <el-option v-for="item in langueOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                </el-select>

              </el-descriptions-item>

              <el-descriptions-item :span="5" label="格式信息">
                <span style="margin-left:5px">{{ item.resourceSuffix }}</span>
              </el-descriptions-item>

            </el-descriptions>
          </div>
          <div v-else style="width:876px;margin-left:10px">
            <el-descriptions class="descriptions" title="" direction="horizontal" size="mini" :column="5" border>
              <el-descriptions-item :span="5" label="资源名称">
                <el-input v-model="item.resourceName" maxlength="50" show-word-limit style="width:100%" placeholder="请输入" size="normal" />
              </el-descriptions-item>
              <el-descriptions-item :span="5" label="资源描述">
                <el-input v-model="item.description" maxlength="100" show-word-limit style="width:100%" placeholder="请输入" size="normal" />
              </el-descriptions-item>
              <el-descriptions-item label="资源体载">

                <!-- <div style="width:114px">18100000000</div> -->
                <!-- <el-select class="resourse descriptions-one" style="width:106px" v-model="form.select" placeholder="">
                <el-option label="餐厅名" value="1"></el-option>
                <el-option label="订单号" value="2"></el-option>
                <el-option label="用户电话" value="3"></el-option>
              </el-select> -->
                <div class="resourse descriptions-one">
                  <el-cascader ref="cascaderhandle" v-model="item.genre" class="trantree" clearable :show-all-levels="false" :options="genretree" :props="genreProps" @change="changeTrain" />

                </div>

              </el-descriptions-item>
              <el-descriptions-item label="创作日期">
                <el-select v-model="item.chronicleDate" clearable class="resourse descriptions-one" placeholder="" @focus="focustotal(index)">
                  <!-- <el-option label="餐厅名" value="1"></el-option>
                <el-option label="订单号" value="2"></el-option>
                <el-option label="用户电话" value="3"></el-option> -->

                  <el-option v-for="(item, index) in datatotal" :key="index" :label="item" :value="item" />
                </el-select>
              <!-- <div style="width:114px">18100000000</div> -->
              </el-descriptions-item>
              <el-descriptions-item label="纪事人物">
                <el-select v-model="item.personAffected" class=" resourse descriptions-one inputtag " collapse-tags multiple placeholder="">
                  <el-option v-for="(item, index) in personAffectedform" :key="index" :label="item" :value="item" />
                </el-select>

              </el-descriptions-item>

              <el-descriptions-item :span="3" label="内容语种">

                <el-select v-model="item.langue" clearable class="resourse descriptions-two" placeholder="">
                  <el-option v-for="item in langueOptions" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                </el-select>

              </el-descriptions-item>

              <el-descriptions-item :span="5" label="格式信息">
                <span style="margin-left:5px">{{ item.resourceSuffix }}</span>
              </el-descriptions-item>

            </el-descriptions>
          </div>
          <div style="  margin-left: 10px;">
            <div class="updown">
              <el-button style="width:29px;height:30px" :style="index===0?'color:#1F233E;opacity: 0.2;':'color:#1F233E'" type="text" size="mini" icon="el-icon-caret-top" @click="upNumber(index)" />
              <span class="updown-border">{{ index+1 }}</span>
              <el-button style="width:29px;height:30px" :style="form.resources.length===(index+1)?'color:#1F233E;opacity: 0.2;':'color:#1F233E'" type="text" size="mini" icon="el-icon-caret-bottom" @click="downNumber(index)" />
            </div>

            <el-button style="width:29px;height:30px;color:#7B84A1;font-weight:bold" type="text" size="mini" icon="el-icon-close" @click="deleteRow(index)" />

          </div>
        </div>

      </div>
      <div id="next" class="dashboard-container" style="padding:0px;margin-bottom:20px">
        <el-button v-loading="btnloding" type="primary" style="width:100%;background-color:#4C70E8;font-size: 14px;font-weight:bold;border-radius: 5px;" size="default" @click="onSubmit('form')">下一步，提交审核</el-button>

      </div>
    </div>
    <div>
      <div class="rowright">

        <div class="rowright-contain" @click="scrollViewId('#library')">

          <span class="rowright-btn"> 馆藏著录</span>
        </div>
        <div class="rowright-contain" style="margin-top:5px" @click="scrollViewId('#resourse')">

          <span class="rowright-btn"> 资源著录</span>
        </div>
        <div class="rowright-contain" style="margin-top:5px;height:54px;background-color:#4C70E8;" @click="scrollViewId('#next')">

          <p class="rowright-next"> 下一步</p>

          <span class="rowright-btn" style="margin-top:4px">提交审核</span>
        </div>

      </div>
    </div>
    <resourcedescription ref="resourcedescription" @changeresourcedescription="changeresourcedescription" />
    <select-image ref="selectImage" @changeImage="changePrever" />
    <lookimage ref="lookimage" />
    <tipall ref="tipall" />
    <videoplay ref="videoplay" />
  </div>
</template>

<script>
import {
  collectionResource,
  removeResourse,
  inputReferParse,
  cataloging,
  regionlistByName
} from '@/api/library'
import {
  getTopicTree,
  getRegiontree,
  getGenreTree,
  getCategoryTree,
  getSubjectTree,
  getTenantList,
  getDictList
} from '@/api/publish'
import {
  ossUpload
} from '@/api/upload'

import resourcedescription from './resourcedescription.vue'
import SelectImage from './selectImage.vue'

import tipall from './tipall.vue'

import Lookimage from './lookimage.vue'
import Videoplay from './videoplay.vue'
export default {
  components: {
    resourcedescription,
    SelectImage,
    Lookimage,
    tipall,
    Videoplay
  },
  props: {
    nextStatus: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      adressing: false,
      adressoptions: [],
      loading: true,
      // rules: {
      //   copyrightOwnerType: [{
      //     required: true,
      //     message: '请填写版权拥有者类型',
      //     trigger: 'change'
      //   }],
      // },
      btnloding: false,
      form: {
        id: 0,
        collectionName: '',
        subtitle: '',
        chapterOrder: '',
        chapter: '',
        cateId: '',
        subjectId: '',
        topicId: '',
        responsibleOfficer: '',
        responsibleMethod: '',
        otherResponsibleOfficer: '',
        otherResponsibleMethod: '',
        publications: '',
        publisher: '',
        publishArea: '',
        publishTime: '',
        publicationsType: '',
        publicationsCode: '',
        copyrightOwner: '',
        copyrightOwnerType: '',
        collectionLevel: '',
        copyrightExpiresTime: '',
        transWeb: '',
        ageRange: '',
        collectionInfo: '',
        description: '',
        preview: '',
        keyword: '',
        chronicleDate: '',
        areaAffected: '',
        areaAffectedName: '',
        personAffected: '',
        resources: []
      },

      categoryProps: {
        children: 'children',
        value: 'id',
        label: 'cateName'
      },
      subjectProps: {
        children: 'children',
        value: 'id',
        label: 'subjectName'
      },
      regionProps: {
        children: 'children',
        value: 'regionCode',
        label: 'regionName'
      },
      genreProps: {
        children: 'children',
        value: 'genreCode',
        label: 'genreName',
        expandTrigger: 'hover',
        checkStrictly: true // 可以选择任意一级
      },
      personList: [],
      dataTimeList: [],
      adressList: [],
      intpus: '18100000000',
      inputsTags: '',
      inputDataTags: '',
      inputAdressTags: '',
      inputPersonTags: '',
      number: 1,

      copyrightOptions: [], // 版权拥有者
      publicationOptions: [], // 来源出版物标识符
      collectionleverOptions: [], // 馆藏级别
      typicalagerangeOptions: [], // 典型年龄范围，
      langueOptions: [], // 语种
      regiontree: [], // 行政区域树.
      genretree: [], // 体裁分类树
      categoryTree: [], // 分类树
      topicTree: [], // 专题
      subjectTree: [], // 学科树

      areaAffectedform: [], // 馆藏地点
      personAffectedform: [], // 馆藏人物
      // chronicleDateform: [], // 馆藏时间
      resourseIndex: 0,
      tenantIdOptions: []
    }
  },
  
  // watch: {
  //   this.form.chapterOrder (val) {
  //     this.dbPort = val.replace(/\D/g, '')
  //   }
  // },
  computed: {
    datatotal() {
      const list = []
      if (this.form.chronicleDate) {
        list.push(this.form.chronicleDate)
      }
      // list = list.concat(this.chronicleDateform)
      const resourse = this.form.resources[this.resourseIndex]
      if (resourse.resourceCreateTime && list.indexOf(resourse.resourceCreateTime) === -1) {
        list.push(resourse.resourceCreateTime)
      }
      if (resourse.resourceUpdateTime && list.indexOf(resourse.resourceUpdateTime) === -1) {
        list.push(resourse.resourceUpdateTime)
      }
      return list
    }
  },
  mounted() {
    // if (this.categoryTree.length === 0) {
    //   this.getCategoryTree()
    // }
    // if (this.subjectTree.length === 0) {
    //   this.getSubjectTree()
    // }
    // this.getDictList()
    // this.getTopicTree()
    // if (this.regiontree.length === 0) {
    //   this.getRegiontree()
    // }
    // if (this.genretree.length === 0) {
    //   this.getGenreTree()
    // }
    // if (this.tenantIdOptions.length === 0) {
    //   this.getTenantList()
    // }
    this.requestTrees()
    this.collectionResource()
  },
  methods: {
    requestTrees() {
      const that = this
      getCategoryTree({ tenantId: this.$store.getters.tenantId }).then(r => {
        that.categoryTree = r.data
      })
      getTenantList().then(r => {
        that.tenantIdOptions = r.data
      })
      getSubjectTree().then(r => {
        that.subjectTree = r.data
      })
      this.getTopicTree()
      this.getDictList()
      getGenreTree().then(r => {
        r.data.forEach(element => {
          element.disabled = true
        })
        that.genretree = r.data
      })
      getRegiontree().then(r => {
        that.regiontree = r.data
      })
    },
    tenantIdFormat(cellValue) {
      if (cellValue != null && cellValue !== '') {
        const item = this.tenantIdOptions.find(item => {
          return cellValue === item.tenantId
        })
        if (item) {
          return item.tenantName
        }
      }
      return ''
    },
    // async getTenantList() {
    //   const res = await this.$store.dispatch('user/getTenantList')
    //   this.tenantIdOptions = res
    // },
    focustotal(index) {
      this.resourseIndex = index
    },
    async fileupload(option) {
      var formData = new FormData()
      console.log(option)
      formData.append('file', option.file)
      formData.append('tenantId', this.$store.getters.tenantId)
      const res = await ossUpload(formData)
      this.form.preview = res.data
      // console.log(res);
    },
    async inputReferParse(value) {
      //  var pattern=/^\d+$/g;  //正则表达式 ^ 代表从开始位置起   $ 末尾   + 是连续多个  \d 是数字的意思   不懂的话可以去百度正则表达式表
      //       var result= srt.match(pattern);//match 是匹配的意思   用正则表达式来匹配
      if (!value) {
        return
      }
      const res = await inputReferParse({
        input: value
      })
      // this.dataTimeList = []

      // const reg = /^[^\u4e00-\u9fa5]{1,20}$/;
      var reg = /^[1-9]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])$/
      var reg1 = /^[1-9]\d{3}$/
      var reg2 = /^[1-9]\d{3}\/(0[1-9]|1[0-2])$/

      res.data.datetimes.forEach(element => {
        const index = this.dataTimeList.findIndex(item => {
          return item.name === element
        })
        if (index === -1) {
          if (reg.test(element) || reg1.test(element) || reg2.test(element)) {
            this.dataTimeList.push({
              name: element,
              isclick: true
            })
          } else {
            this.dataTimeList.push({
              name: element,
              isclick: false
            })
          }
        }
      })

      res.data.persons.forEach(element => {
        const index = this.personList.findIndex(item => {
          return item === element
        })
        if (index === -1) {
          this.personList.push(element)
        }
      })
      res.data.address.forEach(element => {
        const index = this.adressList.findIndex(item => {
          return item.regionCode === element.regionCode
        })
        if (index === -1) {
          this.adressList.push(element)
        }
      })
    },
    // async inputReferParse() {
    //   //  var pattern=/^\d+$/g;  //正则表达式 ^ 代表从开始位置起   $ 末尾   + 是连续多个  \d 是数字的意思   不懂的话可以去百度正则表达式表
    //   //       var result= srt.match(pattern);//match 是匹配的意思   用正则表达式来匹配

    //   const res = await inputReferParse({
    //     input: this.form.description
    //   })
    //   this.dataTimeList = []

    //   // const reg = /^[^\u4e00-\u9fa5]{1,20}$/;
    //   var reg = /^[1-9]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])$/
    //   var reg1 = /^[1-9]\d{3}$/
    //   var reg2 = /^[1-9]\d{3}\/(0[1-9]|1[0-2])$/

    //   res.data.datetimes.forEach(element => {
    //     if (reg.test(element)) {
    //       this.dataTimeList.push({
    //         name: element,
    //         isclick: true
    //       })
    //     } else if (reg1.test(element)) {
    //       this.dataTimeList.push({
    //         name: element,
    //         isclick: true
    //       })
    //     } else if (reg2.test(element)) {
    //       this.dataTimeList.push({
    //         name: element,
    //         isclick: true
    //       })
    //     } else {
    //       this.dataTimeList.push({
    //         name: element,
    //         isclick: false
    //       })
    //     }
    //   })
    //   this.personList = res.data.persons

    //   this.adressList = res.data.address
    // },
    changeTrain(value) {
      this.$refs.cascaderhandle.forEach(element => {
        element.dropDownVisible = false
      })
    },
    // async getGenreTree() {
    //   const res = await this.$store.dispatch('user/getGenreTree')
    //   this.genretree = res
    // },
    // async getRegiontree() {
    //   const res = await this.$store.dispatch('user/getRegiontree')
    //   this.regiontree = res[0].children
    // },
    async getDictList() {
      const res = await getDictList()
      console.log(res)
      res.data.forEach(element => {
        if (element.code === 'copyright_owner') {
          this.copyrightOptions = element.children
        } else if (element.code === 'publication_logo') {
          this.publicationOptions = element.children
        } else if (element.code === 'collection_level') {
          this.collectionleverOptions = element.children
        } else if (element.code === 'typical_age_range') {
          this.typicalagerangeOptions = element.children
        } else if (element.code === 'langue') {
          console.log(element.children)
          this.langueOptions = element.children
        }
      })
      // if (this.$store.getters.dictList.length === 0) {
      //   const res = await getDictList()

      //   res.forEach(element => {
      //     if (element.code === 'copyright_owner') {
      //       this.copyrightOptions = element.children
      //     } else if (element.code === 'publication_logo') {
      //       this.publicationOptions = element.children
      //     } else if (element.code === 'collection_level') {
      //       this.collectionleverOptions = element.children
      //     } else if (element.code === 'typical_age_range') {
      //       this.typicalagerangeOptions = element.children
      //     } else if (element.code === 'langue') {
      //       this.langueOptions = element.children
      //     }
      //   })
      // } else {
      //   this.$store.getters.dictList.forEach(element => {
      //     if (element.code === 'copyright_owner') {
      //       this.copyrightOptions = element.children
      //     } else if (element.code === 'publication_logo') {
      //       this.publicationOptions = element.children
      //     } else if (element.code === 'collection_level') {
      //       this.collectionleverOptions = element.children
      //     } else if (element.code === 'typical_age_range') {
      //       this.typicalagerangeOptions = element.children
      //     } else if (element.code === 'langue') {
      //       this.langueOptions = element.children
      //     }
      //   })
      // }
    },
    // async getCategoryTree() {
    //   const res = await this.$store.dispatch('user/getCategoryTree')
    //   this.categoryTree = res
    // },
    async getTopicTree() {
      const res = await getTopicTree({
        tenantId:this.$store.getters.tenantId
      })
      this.topicTree = res.data
    },

    // async getSubjectTree() {
    //   const res = await this.$store.dispatch('user/getSubjectTree')
    //   this.subjectTree = res
    // },
    // 查看资源
    lookResourse(item) {
      if (item.resourceType === 'video') {
        this.$refs.videoplay.playVideo(item.resourceCloudUrl)
      } else if (item.resourceType === 'audio') {
        this.$refs.videoplay.playVideo(item.resourceCloudUrl)
      } else if (item.resourceType === 'image') {
        this.$refs.lookimage.isOpen(item.resourceCloudUrl)
      } else if (item.resourceType === 'pdf') {
        window.open(item.resourceCloudUrl, '_blank')

        // this.$refs.lookimage.isOpen(item.resourceCloudUrl)
      } else {
        this.$refs.tipall.isOpen('关闭', `暂不支持此格式预览`)
      }
    },
    changePrever(item) {
      this.form.preview = item.image
    },
    selectImage() {
      const list = []

      this.form.resources.forEach(element => {
        if (element.resourceType === 'video') {
          list.push(element.previewUrl)
        } else if (element.resourceType === 'image') {
          list.push(element.resourceCloudUrl)
        }
      })
      this.$refs.selectImage.isOpen(0, list)
    },
    resourseDes() {
      var list = []
      this.form.resources.forEach(element => {
        console.log(element.resourceCreateTime)

        if (element.resourceCreateTime && list.indexOf(element.resourceCreateTime) === -1) {
          list.push(element.resourceCreateTime)
        }
        if (element.resourceUpdateTime && list.indexOf(element.resourceUpdateTime) === -1) {
          list.push(element.resourceUpdateTime)
        }
      })
      // this.chronicleDateform.forEach(element => {
      //   if (list.indexOf(element) === -1) {
      //     list.push(element)
      //   }
      // })
      if (this.form.chronicleDate) {
        if (list.indexOf(this.form.chronicleDate) === -1) {
          list.push(this.form.chronicleDate)
        }
      }

      this.$refs.resourcedescription.isOpen(this.langueOptions, this.genretree, this.personAffectedform, list)
    },
    changeresourcedescription(data) {
      // <el-image v-if="item.resourceType==='video'" :src="item.previewUrl" style="width:100%;height:100%" :lazy="true"></el-image>
      //           <el-image v-else-if="item.resourceType==='image'" :src="item.resourceCloudUrl" style="width:100%;height:100%" :lazy="true"></el-image>

      //           <img v-else-if="item.resourceType==='audio'" src="@/assets/rec1.png" alt="404">
      //           <img v-else-if="item.resourceType==='zip'" src="@/assets/zip1.png" alt="404">
      //           <img v-else-if="item.resourceType==='pdf'" src="@/assets/pdf1.png" alt="404">

      //           <img class="chronicle-bottom-search" @click="lookResourse(item)" src="@/assets/search.png" alt="404">

      this.form.resources.forEach((element, index) => {
        if (data.nametype === '使用资源文件名命名') {
          element.resourceName = element.resourceFileName
        } else {
          if (this.form.collectionName) {
            element.resourceName = this.form.collectionName + '-' + (parseInt(index) + 1)
          }
        }
        if (element.resourceType === 'video') {
          element.description = data.descriptions
          element.personAffected = data.persons
          element.chronicleDate = data.dataTime
          element.genre = data.genre
          element.subtitlesLangue = data.textlangue
          element.videoAndAudioLangue = data.audiolangue
        } else if (element.resourceType === 'audio') {
          element.description = data.descriptions
          element.personAffected = data.persons
          element.chronicleDate = data.dataTime
          element.genre = data.genre
          element.videoAndAudioLangue = data.audiolangue
        } else {
          element.description = data.descriptions
          element.personAffected = data.persons
          element.chronicleDate = data.dataTime
          element.genre = data.genre
          element.langue = data.contextlangue
        }
        console.log(element)
      })
    },
    publicationsTypeChange() {
      if (!this.form.publicationsType) {
        this.$message({
          message: '请填写来源出版物标识符类型',
          type: 'error'
        })
      }
    },
    copyrightOwnerInPutChange() {
      if (!this.form.copyrightOwnerType) {
        this.$message({
          message: '请填写版权拥有者类型',
          type: 'error'
        })
      }
    },
    copyrightChange(value) {
      this.form.copyrightOwner = ''
      this.form.copyrightExpiresTime = ''
      this.form.transWeb = ''
      if (value === 1) {
        this.form.copyrightOwner = this.tenantIdFormat(this.$store.getters.tenantId)
      }
    },
    async collectionResource() {
      this.loading = true
      const res = await collectionResource({
        ids: this.$route.query.collectionId
      })
      this.loading = false
      this.form.id = res.data[0].id
      res.data[0].resources.forEach(element => {
        element.langue = ''
        element.subtitlesLangue = ''
        element.videoAndAudioLangue = ''
      })

      this.form.resources = res.data[0].resources
    },
    categoryTreeChange(value) {
      console.log()
    },
    subjectTreeChange(value) {
      console.log(value)
    },
    topicChange(value) {
      if ((typeof value === 'string') && value.length > 20) {
        this.$message({
          message: '新建专题不能超过' + 20 + '长度',
          type: 'error'
        })
        this.form.topicId = ''
      }
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.copyrightOwnerType === '' || this.form.copyrightOwnerType === null) {
            this.$message({
              message: '请选择版权拥有者类型',
              type: 'error'
            })
            return
          }
          var error = false
          for (let index = 0; index < this.form.resources.length; index++) {
            const item = this.form.resources[index]
            if (item.resourceName === '' || item.resourceName === null) {
              this.$message({
                message: '请填写资源名称',
                type: 'error'
              })
              error = true
              break
            } else if (item.resourceName.length > 50) {
              this.$message({
                message: '资源名换过长',
                type: 'error'
              })
              error = true
              break
            }
          }
          if (error === false) {
            this.cataloging()
          }
          // this.form.resources.forEach(element => {
          //   if (element.resourceName === '' || element.resourceName === null) {
          //     this.$message({
          //       message: '请填写资源名称',
          //       type: 'error'
          //     })
          //     return
          //   } else if (element.resourceName.length > 50) {
          //     this.$message({
          //       message: '资源名换过长',
          //       type: 'error'
          //     })
          //     return
          //   }
          // })
        } else {
          this.$message({
            message: '请注意必填项必须填写',
            type: 'error'
          })
          return false
        }
      })
    },

    getareaAffectedName() {
      var list = []
      if (this.areaAffectedform.length > 0) {
        this.areaAffectedform.forEach(item => {
          list.push(item.regionName)
        })
        return list.toString()
      }
      return ''
    },
    getareaAffected() {
      var list = []
      if (this.areaAffectedform.length > 0) {
        this.areaAffectedform.forEach(item => {
          list.push(item.regionCode)
        })
        return list.toString()
      }
      return ''
    },
    async cataloging() {
      var dataForm = {
        id: this.form.id,
        collectionName: this.form.collectionName,
        subtitle: this.form.subtitle,
        chapterOrder: this.form.chapterOrder,
        chapter: this.form.chapter,
        cateId: this.form.cateId[this.form.cateId.length - 1],
        subjectId: '',
        responsibleOfficer: this.form.responsibleOfficer,
        responsibleMethod: this.form.responsibleMethod,
        otherResponsibleOfficer: this.form.otherResponsibleOfficer,
        otherResponsibleMethod: this.form.otherResponsibleMethod,
        publications: this.form.publications,
        publisher: this.form.publisher,
        publishTime: this.form.publishTime,
        publicationsType: this.form.publicationsType,
        publicationsCode: this.form.publicationsCode,
        copyrightOwner: this.form.copyrightOwner,
        copyrightOwnerType: this.form.copyrightOwnerType,
        collectionLevel: this.form.collectionLevel,
        ageRange: this.form.ageRange,
        copyrightExpiresTime: this.form.copyrightExpiresTime,
        transWeb: this.form.transWeb,
        collectionInfo: this.form.collectionInfo,
        description: this.form.description,
        preview: this.form.preview,
        keyword: this.form.keyword,
        chronicleDate: this.form.chronicleDate,
        areaAffected: this.getareaAffected(),
        status: this.nextStatus,
        areaAffectedName: this.getareaAffectedName(),
        personAffected: this.personAffectedform.toString(),
        resources: []
      }
      if (this.form.publishArea.length > 0) {
        dataForm.publishArea = this.form.publishArea[this.form.publishArea.length - 1]
      }

      if (this.form.subjectId) {
        dataForm.subjectId = this.form.subjectId[this.form.subjectId.length - 1]
      }
      // if (this.form.topicId !== '') {
      //   dataForm.topicName = this.form.topicId
      //   dataForm.topicId = -1
      // }
      if (this.form.topicId !== '') {
        if ((typeof this.form.topicId === 'string')) {
          dataForm.topicName = this.form.topicId
          dataForm.topicId = -1
        } else {
          dataForm.topicId = this.form.topicId
        }
      }
      this.form.resources.forEach((element, index) => {
        var item = {}
        for (const key in element) {
          if (key === 'genre') {
            item[key] = element[key] === '' ? '' : element[key][element[key].length - 1]
          } else if (key === 'sort') {
            item[key] = index + 1
          } else if (key === 'personAffected') {
            item[key] = element[key].toString()
          } else {
            item[key] = element[key]
          }
        }
        console.log(JSON.stringify(item))
        dataForm.resources.push(item)
      })
      this.btnloding = true
      const res = await cataloging({
        collectionVOs: [dataForm],
        tenantId: this.$store.getters.tenantId
      })
      this.btnloding = false
      if (res.data) {
        this.uploadnext()
      }
    },
    uploadnext() {
      this.$emit('uploadNext')
    },
    // downNumber(index) {

    //   this.form.resources[index] = this.form.resources.splice(index + 1, 1, this.form.resources[index])[0];

    // },

    swapItems(index1, index2) {
      this.form.resources[index1] = this.form.resources.splice(index2, 1, this.form.resources[index1])[0]
    },

    upNumber(index) {
      this.swapItems(index, index - 1)
    },
    downNumber(index) {
      this.swapItems(index, index + 1)
    },

    // upNumber(index) {

    //   this.form.resources[index] = this.form.resources.splice(index - 1, 1, this.form.resources[index])[0];

    // },
    async deleteRow(index) {
      this.$confirm('是否删除该条资源！删除后无法找回', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.removeResourse(index)
      }).catch(() => {

      })
    },
    async removeResourse(index) {
      const res = await removeResourse({
        ids: this.form.resources[index].id
      })
      if (res.data) {
        this.form.resources.splice(index, 1)
      }
    },

    removeChronicleDate() {
      this.form.chronicleDate = ''
      // this.chronicleDateform.splice(index, 1)
    },
    inputChronicleDate(item) {
      if (item.isclick) {
        // if (this.chronicleDateform.indexOf(item.name) === -1) {
        //   this.chronicleDateform.push(item.name)
        // }
        this.form.chronicleDate = item
      }
    },
    inputDateTagsChange() {
      if (this.inputDataTags) {
        // if (this.chronicleDateform.indexOf(this.inputDataTags) !== -1) {
        //   this.inputDataTags = ''
        //   return
        // }

        var reg = /^[1-9]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])$/
        var reg1 = /^[1-9]\d{3}$/
        var reg2 = /^[1-9]\d{3}\/(0[1-9]|1[0-2])$/
        if (reg.test(this.inputDataTags)) {
          this.form.chronicleDate = this.inputDataTags
        } else if (reg1.test(this.inputDataTags)) {
          this.form.chronicleDate = this.inputDataTags
        } else if (reg2.test(this.inputDataTags)) {
          this.form.chronicleDate = this.inputDataTags
        } else {
          this.$message({
            message: '输入不规范',
            type: 'error'
          })
        }
      }
      this.inputDataTags = ''
    },
    removeChronicleAdress(index) {
      this.areaAffectedform.splice(index, 1)
    },
    inputChronicleAdress(item) {
      const index = this.areaAffectedform.findIndex(element => {
        return item.regionCode === element.regionCode
      })
      if (index === -1) {
        this.areaAffectedform.push(item)
      }
      // if (this.areaAffectedform.indexOf(item) === -1)
      //   this.areaAffectedform.push(item)
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.adressing = true
        const res = await regionlistByName({
          regionName: query
        })
        this.adressing = false
        if (res.data) {
          this.adressoptions = res.data
        }
      } else {
        this.adressoptions = []
      }
    },
    inputAdressTagsChange(value) {
      const regin = this.adressoptions.find(item => {
        return item.regionCode === value
      })
      if (regin) {
        const index = this.areaAffectedform.findIndex(item => {
          return item.regionCode === regin.regionCode
        })
        regin.regionName = regin.allRegionName
        // console.log(regin);
        if (index === -1) {
          this.areaAffectedform.push(regin)
        }
      }
      this.adressoptions = []
      this.inputAdressTags = ''
    },
    inputChroniclePerson(item) {
      if (this.personAffectedform.indexOf(item) === -1) {
        this.personAffectedform.push(item)
      }
    },
    removeChroniclePerson(index) {
      this.personAffectedform.splice(index, 1)
    },
    inputPersonTagsChange() {
      if (this.inputPersonTags) {
        if (this.personAffectedform.indexOf(this.inputPersonTags) === -1) {
          this.personAffectedform.push(this.inputPersonTags)
        }
      }
      this.inputPersonTags = ''
    },
    // changeDescript() {
    //   this.inputReferParse()
    // },
    changeDescript(event) {
      // console.log(event.target.value);
      this.inputReferParse(event.target.value)
    },
    scrollViewId(name) {
      document.querySelector(name).scrollIntoView(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.trantree {
  .el-cascader-panel .el-radio {
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .el-cascader-panel .el-radio__input {
    visibility: hidden;
  }

  .el-cascader-panel .el-cascader-node__postfix {
    top: 10px;
  }
}

::v-deep .el-cascader {
  display: inline-block;
  position: relative;
  font-size: 14px;
  line-height: 30px !important;
}

::v-deep .el-input__icon {
  height: 100%;
  width: 15px;

}

::v-deep .el-divider--horizontal {

  margin: 20px 0;
}

::v-deep .el-select .el-tag {

  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-color: transparent;
  margin: 0px 0 0px 2px !important;
  background-color: #f0f2f5;

}

.inputtag {
  ::v-deep .el-select__tags {
    max-width: 90px !important;
  }

  ::v-deep .el-tag.el-tag--info {
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;
    /* width: 50px; */
    max-width: 72px;
    overflow: hidden;
    display: flex;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }

  ::v-deep .el-tag--small {
    height: 24px;
    padding: 0 2px 0 2px;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ::v-deep .el-select__tags-text {
    max-width: 35px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ::v-deep .el-tag .el-icon-close {
    border-radius: 50%;
    text-align: center;

    top: 50%;
    margin-top: -20px;

    right: 0px;
    vertical-align: middle;

  }
}

.chronicle {

  // <el-button type="primary" icon="el-icon-delete"></el-button>

  &-bottom {

    width: 174px;
    height: 121px;
    flex-wrap: wrap;
    display: flex;

    &-type {

      width: 174px;
      height: 121px;
      background: #F9F9FC;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 1px solid #DEE0E7;
      position: relative;
      cursor: pointer;
    }

    &-search {
      position: absolute;
      left: 0px;
      bottom: 0px;

      background-color: #4C70E8;
      width: 20px;
      height: 20px;
      z-index: 100;
    }

    &-text {

      height: 26px;
      font-size: 12px;
      width: 105px;
      color: #1F233E;
      line-height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.discript {
  ::v-deep .el-textarea__inner {
    padding: 5px 10px;
    resize: none;
    height: 170px;
    border-radius: 0px;
    background-color: #F9F9FC;
    border: 1px solid #DEE0E7 !important;
  }
}

.updown {
  width: 29px;
  height: 90px;
  display: flex;

  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  color: #000;
  border: 1px solid #DEE0E7;

  &-border {
    width: 29px;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    color: #1F233E;
    text-align: center;
    border: 1px solid #DEE0E7;
    background-color: #FFFFFF;
    // border: 1px solid #DEE0E7;
    // border-radius: 3px;
  }

  ;

  &-text {

    font-size: 12px;

    color: #1F233E;

  }
}

::v-deep .el-form-item__label {
  font-size: 14px !important;
  color: #1F233E !important;

}

.lable-none {
  ::v-deep .el-form-item__label {
    font-size: 14px !important;
    color: #1F233E !important;
    float: none !important;
  }
}

::v-deep .el-form-item__content {
  line-height: 30px !important;
  font-size: 12px !important;
}

::v-deep .el-form-item__label::before {
  content: '' !important;
  color: #F56C6C !important;
  margin-right: 4px !important;
}

::v-deep .el-input__icon {
  line-height: 30px;
}

.require {
  ::v-deep .el-form-item__label::after {
    content: '*';
    text-align: center;
    position: relative;
    top: 5px;
    color: #FA5E5F !important;
    font-size: 16px;
    margin-left: 4px !important;
  }
}

.placeholder-span {
  font-size: 12px;
  color: #7B84A1;
  line-height: 18px;
}

::v-deep .el-select__input {
  width: 100px !important;
  height: 30px;
}

.image {
  width: 100%;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F9F9FC;
  border: 1px solid #DEE0E7;
}

.upload {
  width: 100%;
  height: 170px;
  display: flex;

  flex-direction: column;

  &-btn {
    width: 160px;
    height: 40px;
    cursor: pointer;
    background: #FFFFFF;
    border: 1px solid #F3F4F9;
    color: #4C70E8;
    display: flex;

    font-weight: bold;
    align-items: center;
    font-size: 12px;
  }
}

::v-deep .el-input__inner {
  padding: 0px 10px;
  background-color: #F9F9FC !important;
  border: 1px solid #DEE0E7 !important;
  border-radius: 0px;
  line-height: 30px;
  font-size: 12px;
  height: 30px;

}

.select {

  ::v-deep .el-input__inner {

    background-color: #F9F9FC !important;
    border-bottom: 1px solid #DEE0E7 !important;
    border-top: 1px solid #DEE0E7 !important;
    border-right: 0px solid #DEE0E7 !important;
    border-left: 1px solid #DEE0E7 !important;

  }
}

.cascader {
  ::v-deep .el-input-group__prepend {

    // vertical-align: initial;
    display: table-cell;
    position: relative;
    padding: 0 0px !important;
    border-bottom: 0px solid #DEE0E7;

    border-left: 0px solid #DEE0E7;
    border-radius: 0px !important;
    border-top: 0px solid #DEE0E7;
    padding: 0px 2px;
    background-color: #FFFFFF;
    width: 1px;
    white-space: nowrap;
  }
}

::v-deep .el-input-group__prepend {

  // vertical-align: initial;
  display: table-cell;
  position: relative;
  top: -1px;
  border-bottom: 0px solid #DEE0E7;
  border-top: 0px solid #DEE0E7;
  border-left: 0px solid #DEE0E7;
  border-radius: 0px !important;

  background-color: #FFFFFF;
  width: 1px;
  white-space: nowrap;
}

.descriptions {
  width: 876px;

  ::v-deep .is-bordered-label {
    font-weight: 700;
    color: #fff;
    width: 80px;
    text-align: center;
    background: #fafafa;
    width: 70px;
    height: 29px;
    background-color: #FFFFFF;
    border: 1px solid #DEE0E7;
    font-size: 12px;
    color: #1F233E;

  }

  ::v-deep .el-input__inner {
    padding: 0px 5px;
    background-color: #F9F9FC !important;
    border: none !important;
    border-radius: 0px;
    line-height: 29px;
    font-size: 12px;
    height: 29px;
  }

  &-one {
    width: 106px;
  }

  &-two {
    width: 280px;

  }

  // .el-descriptions--mini.is-bordered td, .el-descriptions--mini.is-bordered th
  ::v-deep .el-descriptions--mini.is-bordered th {
    padding: 5px 5px !important;
  }

  ::v-deep .el-descriptions--mini.is-bordered td {
    padding: 0px 0px !important;
  }

  ::v-deep .el-descriptions .is-bordered td,
  .el-descriptions .is-bordered th {
    border: 1px solid #EBEEF5;
    background-color: #F9F9FC;
    padding: 0px;
  }

}

.resourse {

  // ::v-deep .el-select{
  //   padding: 0px;
  // }
  // ::v-deep input {
  //   white-space: nowrap;
  //   text-overflow: ellipsis;
  //   overflow: hidden;
  //   font-size: 12px;
  // }

  // ::v-deep .el-select .el-input__inner {
  //   cursor: pointer;
  //   padding: 0px;
  //   width: 114px;
  //   white-space: nowrap;
  //   text-overflow: ellipsis;
  //   overflow: hidden;
  //     font-size: 12px;
  // }

  // ::v-deep .el-select .el-input__inner {
  //   cursor: pointer;
  //   padding: 0px;
  //   width: 114px;
  //   white-space: nowrap;
  //   text-overflow: ellipsis;
  //   overflow: hidden;
  //     font-size: 12px;
  // }

  ::v-deep .el-input__inner {
    border: 0px solid #DCDFE6 !important;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    background-color: #F9F9FC !important;
    height: 29px;
    line-height: 29px;
    outline: 0;
    padding-left: 5px;
    padding-right: 20px !important;
    font-size: 12px !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
  }
}
.count {
  ::v-deep .el-input__count {
    color: #909399;
    // background: #FFF;
    position: absolute;
    font-size: 12px;
    height: 40px;
    top: -40px;
    right: 0px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
// ::v-deep .el-input__count {
//   color: #909399;
//   // background: #FFF;
//   position: absolute;
//   font-size: 12px;
//   height: 40px;
//   top: -40px;
//   right: 0px;
//   white-space: nowrap;
//   text-overflow: ellipsis;
//   overflow: hidden;
// }

.placeholder {
  text-align: right;
  vertical-align: middle;
  float: right;
  font-size: 12px;
  color: #000;
  line-height: 40px;
  color: #b7bccd;
  // padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.tags {
  width: 100%;
  height: 90px;
  padding: 10px;
  display: flex;
  background-color: #FFFFFF;
  box-sizing: border-box;
  // border-radius: 4px;
  border: 1px solid #DCDFE6;
  color: #C0C4CC;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow: auto;

  background: #FFFFFF;
  border: 1px solid #DEE0E7;

  ::v-deep .el-tag {
    padding: 0 5px;
  }

  ::v-deep .el-tag .el-icon-close {
    right: 0px;
  }

  ::v-deep .el-tag.el-tag--info {
    background-color: #BDC1D0;
    border-color: #BDC1D0;

    height: 20px;

    font-size: 12px;

    color: #FFFFFF;
    line-height: 18px;
    border-radius: 5px;
  }

  ::v-deep .el-tag.el-tag--success {
    background-color: #4C70E8;
    border-color: #4C70E8;

    height: 20px;

    font-size: 12px;

    color: #FFFFFF;
    line-height: 18px;
    border-radius: 5px;
  }

  ::v-deep .el-tag.el-tag--info .el-tag__close {
    color: #FFFFFF;
  }

  &-input {
    ::v-deep .el-input__inner {
      border-radius: 0px;
      // border: 1px solid #DCDFE6;
      // border-bottom: ;
      width: 100%;
      background-color: #F9F9FC;
      border-top: none !important;
      border-bottom: 1px solid #DEE0E7;
      border-right: 1px solid #DEE0E7;
      border-left: 1px solid #DEE0E7;
    }

    ::v-deep .el-input-group__append {

      vertical-align: middle;
      display: table-cell;
      position: relative;
      // width: 30px !important;
      border-top: none !important;
      border-bottom: 1px solid #DEE0E7;
      border-right: 1px solid #DEE0E7;
      border-left: 0px solid #DEE0E7;
      border-radius: 0px !important;
      padding: 0px 2px;
      background-color: #FFFFFF;
      width: 1px;
      white-space: nowrap;
    }

    ::v-deep .el-input__inner:focus {
      // border-color:#F5F7FA
      background-color: #fff;
      border: 1px solid #DCDFE6;
    }
  }
}

::v-deep .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 16px;
  color: #000;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

::v-deep .el-textarea__inner {
  padding: 5px 10px;
  resize: none;
  height: 50px;
  border-radius: 0px;
  background-color: #F9F9FC;
  border: 1px solid #DEE0E7 !important;
}

::v-deep .el-select .el-input__inner {
  cursor: pointer;
  // padding-right: 35px;
  padding: 10px 5px;
}

::v-deep .el-date-editor .el-input__inner {
  padding-left: 30px;
}

.row {
  flex-direction: row;
  display: flex;
  align-items: center;

  &-img {
    opacity: 0.5;
  }

  &-img:hover {
    opacity: 1;
  }
}

.rowright {
  display: flex;
  position: fixed;
  top: 200px;
  width: 100px;
  flex-direction: column;

  &-contain {
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;
    padding-left: 10px;
    height: 30px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #b7bccd;
    cursor: pointer;
  }

  &-btn {
    font-size: 12px;
    width: 100px;
    color: #FEFEFE;

  }

  &-next {

    padding: 0px;
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
    color: #FEFEFE;
  }
}

.dashboard {
  margin: auto;
  padding-top: 51px;
  width: 1240px;
  flex-direction: row;
  display: flex;
  box-sizing: border-box;

  &-container {

    padding: 20px;
    border-radius: 5px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  &-toplayout {
    display: flex;
    // flex-direction: row-reverse;
    margin: 0px 0px 10px 0px;
    align-items: center;

    justify-content: space-between;
    color: #000;
    font-size: 14px;
    line-height: 25px;

    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-space {
      display: flex;
      align-items: center;
      padding-left: 10px;
      padding-right: 11px;
      justify-content: space-between;
    }

    &-mgright {
      margin-right: 11px;

      font-size: 12px;
      line-height: 24px;
      color: #1F233E;

    }

    &-num {
      width: 24px;
      height: 24px;
      font-size: 12px;
      margin-right: 11px;
      // line-height: 24px;
      color: #ffff;
      display: flex;
      justify-content: center;
      background: #7B84A1;
      border-radius: 5px;
    }

    &-btn {
      margin-right: 15px;
      height: 24px;
      width: 176px;
      background: #7B84A1;
      border-radius: 5px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 24px;
    }

    &-ftsbig {

      font-size: 20px;
      font-weight: bold;
      color: #4C70E8;

    }

    &-ftsnomal {
      margin-left: -25px;
      font-size: 12px;
      color: #1F233E;
      line-height: 24px;

    }
  }
}
</style>
